<template>

   <div>
        <div class="emojii_tabs">
            <label v-bind:key="tabIndex" v-on:click="setActiveTab(tabIndex)" v-bind:data-tabIndex="tabIndex" v-for="(tab, tabIndex) in filteredTabs" v-bind:title="tab.tabTitle" v-bind:class="['tab-label', tabIndex === activeIconTabIndex ? 'active' : '', tab.tabTitle]">
                <img v-bind:src="tab.tabIconUrl">
            </label>
        </div>

        <section v-bind:key="index" v-touch:swipe="swipeHandler" v-for="(tab, index) in filteredTabs" v-show="index === activeIconTabIndex" v-bind:class="['content-tabs', index === activeIconTabIndex ? 'active' : '', tab.tabTitle]">
            <div v-if="tab.useBackgroundColors !== true" v-bind:class="[tab.isBackground ? 'background' : '', tab.tabTitle, 'emoji-grid owl-carousel owl-theme owl-loaded']">
                <div class="owl-stage-outer">
                    <div class="owl-item">
                        <div class="item">
                            <div v-on:click="$emit('select-icon', icon)" v-bind:data-iconname="icon.name"
                                 v-bind:key="icon.name + iidx" v-for="(icon, iidx) in filteredIcons(tab.icons)"
                                 v-bind:class="[icon.isBackground ? 'background' : 'icon', icon === selectedIcon ? 'emoji-active' : '']">
                                <div>
                                    <img v-bind:id="icon.id" v-bind:src="icon.url" v-bind:alt="icon.id">
                                  <button v-if="icon.isUploaded && (icon === selectedIcon)" v-on:click="deleteImage(icon)"
                                          style="font-weight: bold; color: red; margin-top: 4px; padding: 6px;">X</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="owl-nav">
                    <button type="button" role="presentation" class="owl-prev" v-on:click="prevPage()">
                        <span class="fa fa-chevron-left"></span>
                    </button>
                    <button type="button" role="presentation" class="owl-next" v-on:click="nextPage()">
                        <span class="fa fa-chevron-right"></span>
                    </button>
                </div>
                
                <div class="owl-dots">
                    <button v-bind:key="page" v-for="page in pager" v-on:click="pageNumber = page - 1" role="button" v-bind:class="['owl-dot', pageNumber == (page - 1) ? 'active' : '']"><span></span></button>
                </div>

            </div>
            <div v-if="tab.useBackgroundColors === true">
                <color-selection v-bind:selectedColor="selectedBackgroundColor" v-on:select-color="selectBackgroundColor" v-bind:colors="tab.colors" />
            </div>
        </section>
   </div>
</template>

<script>

import ColorSelection from './ColorSelection.vue'

export default {
    name: 'IconSection',

    components: {
      ColorSelection,
    },

    data: function () {
        return {
            pageNumber: 0,
            activeIconTabIndex: 0,
        }
    },

    props: {
        tabs: Array,
        selectedProduct: Object,
        selectedIcon: Object,
        selectedBackgroundColor: String,
        backgroundModeEnabled: Boolean,
        translations: Object,
    },


    watch: { 
        selectedProduct: function(newProduct) {
            this.pageNumber = 0;
            this.activeIconTabIndex = this.getDefaultTabForProduct(newProduct.id);
        }
    },


    methods: {

        supportSelectedProduct: function (tab, productId) {
            return tab.compatibleProductIds && tab.compatibleProductIds.includes(productId);
        },

        getDefaultTabForProduct(id) {
            var evenMoreFiltered = this.filteredTabs.filter(tab => tab.isBackground === this.backgroundModeEnabled);
            var defaultTab = evenMoreFiltered.findIndex(iconTab => this.supportSelectedProduct(iconTab, id) && iconTab.isDefaultTab);
            if (defaultTab !== -1) return defaultTab;
            return evenMoreFiltered.findIndex(iconTab => this.supportSelectedProduct(iconTab, id));
        },


        selectBackgroundColor (color) {
            this.$emit('select-background-color', color);
        },

        swipeHandler(direction) {
            if (direction === "left") {
                this.nextPage();
            }
            else if(direction === "right") {
                this.prevPage();
            }            
        },

        deleteImage(icon) {
          this.$emit('delete-image', icon.name)
        },

        filteredIcons: function(icons) {
            var pageSize = this.getPageSize();
            const start = this.pageNumber * pageSize, end = start + pageSize;
            return icons.slice(start, end);
        },

        nextPage() {

            this.pageNumber++;
            
            if (this.pageNumber === this.getLastPageIndexForTab()) {

                if (this.selectedProduct.productTab == 1) { // only color stickers can jump to next tab

                    if (this.activeIconTabIndex === this.filteredTabs.length - 1) {  
                        this.activeIconTabIndex = 0; // loop back around
                    }
                    else {
                        this.activeIconTabIndex++;
                    }
                    
                }

                this.pageNumber = 0;
            }
        },

        prevPage() {
            if (this.pageNumber === 0) {

                if (this.selectedProduct.productTab == 1) { // only color stickers can jump to next tab

                    if (this.activeIconTabIndex === 0) {
                        this.activeIconTabIndex = this.filteredTabs.length - 1; // loop back around
                    } else {
                        this.activeIconTabIndex--;
                    }

                }

                this.pageNumber = this.getLastPageIndexForTab() - 1;
            }
            else {
                this.pageNumber--;
            }
        },

        getPageSize() {
            var pageSize = this.filteredTabs[this.activeIconTabIndex]?.pageSize;
            if (pageSize) {
                return parseInt(pageSize);
            }
            else if (this.filteredTabs[this.activeIconTabIndex]?.isBackground) {
                return 14;
            }
            else {
                return 25;
            }
        },

        getLastPageIndexForTab() {
            var l = this.filteredTabs[this.activeIconTabIndex]?.icons.length,
                s = this.getPageSize();
            return Math.ceil(l/s);
        },
        
        setActiveTab(index) {
            this.pageNumber = 0;
            this.activeIconTabIndex = index;
        },

    },


    computed: {

        filteredTabs() {
            return this.tabs.filter(tab => tab.isBackground === this.backgroundModeEnabled);
        },
        
        pager() {
            return this.getLastPageIndexForTab();
        }

    }

}
</script>

